export default {
  STATES: {
    EMPTY: 'Keine Auswahl',
    BREMEN: 'Bremen',
    HAMBURG: 'Hamburg',
    BERLIN: 'Berlin',
    SAARLAND: 'Saarland',
    SCHLESWIG_HOLSTEIN: 'Schleswig-Holstein',
    THURINGIA: 'Thüringen',
    SAXONY: 'Sachsen',
    RHINELAND_PALATINATE: 'Rheinland-Pfalz',
    SAXONY_ANHALT: 'Sachsen-Anhalt',
    HESSE: 'Hessen',
    MECKLENBURG_POMERANIA: 'Mecklenburg-Vorpommern',
    BRANDENBURG: 'Brandenburg',
    NORTHRHINE_WESTPHALIA: 'Nordrhein-Westfalen',
    NORTHRHINE_WESTPHALIA_KV_NORDRHEIN: 'Nordrhein-Westfalen (KV-Nordrhein)',
    NORTHRHINE_WESTPHALIA_KV_WESTFALEN_LIPPE: 'Nordrhein-Westfalen (KV-Westfalen-Lippe)',
    BADEN_WUERTTEMBERG: 'Baden-Württemberg',
    LOWER_SAXONY: 'Niedersachsen',
    BAVARIA: 'Bayern',
  },

  USER_GENDERS: {
    FEMALE: 'Weiblich',
    MALE: 'Männlich',
    DIVERSE: 'Divers',
  },

  WEEKDAYS: [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
    'Sonntag',
  ],

  INSTITUTIONS: [
    'Einzelpraxis',
    'Gemeinschaftspraxis',
    'Berufsausübungsgemeinschaft',
    'Praxisgemeinschaft',
    'Klinik',
    'MVZ',
  ],

  SERVICES: [
    'Allgemeinärztlicher Dienst',
    'Augenärztlicher Dienst',
    'Kinderärztlicher Dienst',
    'HNO-ärztlicher Dienst',
    'Chirurgischer Dienst',
    'Zahnärztlicher Dienst',
    'Gynäkologischer Dienst',
    'Orthopädischer Dienst',
    'Psychiatrischer Dienst'
  ],

  COUNTING: [
    'ersten',
    'zweiten',
    'dritten',
    'vierten',
    'fünften',
    'sechsten',
    'siebten',
    'achten',
    'neunten',
    'zehnten',
  ],

  MEASLES_PROOF_SPECIFICATION: {
    NO: 'Keine',
    SEROLOGICAL_FINDINGS: 'Serologischer Befund',
    CERTIFICATE_OF_VACCINE_INTOLERANCE: 'Attest über Impfunverträglichkeit',
    VACCINATION_CERTIFICATE: 'Impfpass',
    MEDICAL_CERTIFICATE: 'Ärztliche Bescheinigung',
  },
};
